import gql from 'graphql-tag';

export default gql`
  query allBaseUoms {
    allBaseUoms {
      data {
        id
        nameEn
        nameVn
      }
    }
  }
`;
